import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

import Modal from 'components/Modal';
import Loader from 'components/Loader';

import useModal from 'hooks/useModal';
import useGroup from 'hooks/useGroup';

import OptionText from 'components/Group/OptionText';
import OptionImage from 'components/Group/OptionImage';


function ModalAddGroup(props) {
	const {
		group = false,
		forceOpen = false
	} = props;
	const {t} = useTranslation();

	const [type, setType] = useState(1);

	const {
		isShowing,
		hide,
		show
	} = useModal();

	const {
		fetching,
		addGroup,
		estimate,
		fetchingEstimate,
		loadedEstimate,
		resetEstimate
	} = useGroup();


	useEffect(() => {
		resetEstimate();
		if (group !== false && group.config) {
			setType(group.config.type);
		} else {
			setType(1);
		}
	}, [group]);


	useEffect(() => {
		resetEstimate();
	}, [type]);

	useEffect(() => {
		if (forceOpen && !isShowing) {
			return show();
		}
		if (!forceOpen && isShowing) {
			hide();
		}
	}, [forceOpen, show, hide, isShowing]);

	const closeModal = () => {
		if (typeof props.setForceOpenOpen === 'function') {
			props.setForceOpenOpen(false);
		}
		resetEstimate();
		hide();
	}

	const generate = (params) => {
		if (group && group.id && group.main !== true) {
			params.groupId = group.id;
		}
		addGroup(params, () => {
			closeModal();
		});
	}

	let componentEstimate = (
		<div>
			{(fetchingEstimate !== false || loadedEstimate !== false) && (
				<div className="estimate">
					<div className="wrapper-estimate">
						{fetchingEstimate && (
							<Loader className="loader-estimate" />
						)}
						{loadedEstimate && (
							<>
								<ul>
									{estimate.total && (
										<li>
											<b>{t('ModalAddGroup.estimateTotal')} : </b>
											<span>{estimate.total} </span>
										</li>
									)}
									{estimate.width && (
										<li>
											<b>{t('ModalAddGroup.estimateWidth')} : </b>
											<span>{estimate.width} </span>
										</li>
									)}
									{estimate.height && (
										<li>
											<b>{t('ModalAddGroup.estimateHeight')} : </b>
											<span>{estimate.height} </span>
										</li>
									)}
								</ul>
								<ul className="ul-colors">
									{estimate.colors && estimate.colors.map((colorData, indexColor) => {
										return (
											<li key={'color' + indexColor}>
												<div className={'color-thumb' + (colorData.color === 'transparent' ? ' transparent' : '')} style={{
													backgroundColor: colorData.color
												}} />
												<span>{colorData.count} </span>
											</li>
										);
									})}
								</ul>
							</>
						)}
					</div>
				</div>
			)}
		</div>
	);
	return (
		<Modal
			isShowing={isShowing}
			hide={closeModal}
			title={t('ModalAddGroup.title')}
			closeButton={forceOpen}
			className="ModalAddGroup"
		>
			{fetching && (
				<Loader />
			)}
			{!fetching && (
				<div>

					{(
						group === false ||
						(
							group !== false && group.main
						)
					) && (
						<>
							<div className="input-group mb-3" key="block1">
								<label className="input-group-text"
								       htmlFor="inputGroupSelect01">{t('ModalAddGroup.form.labels.type')}</label>
								<select
									className="form-select"
									id="inputGroupSelect01"
									value={type}
									onChange={(evt) => {
										setType(parseInt(evt.target.value, 10));
									}}
								>
									<option value="1">{t('ModalAddGroup.form.type.options.text')}</option>
									<option value="2">{t('ModalAddGroup.form.type.options.image')}</option>
								</select>
							</div>
							<hr />
						</>

					)}

					{type === 1 && (
						<OptionText
							type={type}
							group={group}
							generate={generate}
							nameBtn={(group === false) ? t('add') : t('update')}
							components={{
								estimate: componentEstimate
							}}
						/>
					)}

					{type === 2 && (
						<OptionImage
							type={type}
							group={group}
							generate={generate}
							nameBtn={(group === false) ? t('add') : t('update')}
							components={{
								estimate: componentEstimate
							}}
						/>
					)}
				</div>
			)}

		</Modal>
	);
}

export default ModalAddGroup;
